import { Dropdown, DropdownItem } from "flowbite-react";

const timeRanges = [
  { label: "Last 90 Days", value: "" }, // API default
  { label: "This Month", value: "this_month" },
  { label: "Last Month", value: "last_month" },
  { label: "This Quarter", value: "this_quarter" },
  { label: "Last Quarter", value: "last_quarter" },
  { label: "Last 365 Days", value: "last_365_days" },
  { label: "All Time", value: "all_time" },
];

export const ChurnPageFilters = ({ onTimeRangeChange, selectedTimeRange }) => {
  // Default to empty string (Last 90 Days) if no range is selected
  const normalizedTimeRange = selectedTimeRange ?? "";

  const selectedLabel =
    timeRanges.find((range) => range.value === normalizedTimeRange)?.label ||
    "Last 90 Days";

  return (
    <div className="flex w-full flex-row justify-end p-3">
      <Dropdown label={selectedLabel} color="gray">
        {timeRanges.map((range) => (
          <DropdownItem
            key={range.value || "default"}
            active={range.value === normalizedTimeRange}
            value={range.value}
            onClick={() => onTimeRangeChange(range.value)}
          >
            {range.label}
          </DropdownItem>
        ))}
      </Dropdown>
    </div>
  );
};
